import { useState, useCallback } from "react";
import { CONSTANTS } from "../data";

const useTutorial = () => {
  const [tutorialState, setTutorialState] = useState({
    isTutorialActive: false,
    currentTutorial: null,
    completedTutorials: [],
    skippedTutorials: [],
  });

  const startTutorial = useCallback((tutorialId: string) => {
    const tutorial = CONSTANTS.TUTORIALS[tutorialId];
    if (!tutorial) return;

    setTutorialState(prev => ({
      ...prev,
      isTutorialActive: true,
      currentTutorial: { id: tutorialId, step: 0 },
    }));
  }, []);

  const advanceStep = useCallback(() => {
    setTutorialState(prev => {
      if (!prev.currentTutorial) return prev;

      const tutorial = CONSTANTS.TUTORIALS[prev.currentTutorial.id];
      if (!tutorial) return prev;

      const nextStep = prev.currentTutorial.step + 1;
      
      if (nextStep >= tutorial.steps.length) {
        // Tutorial complete
        return {
          ...prev,
          isTutorialActive: false,
          currentTutorial: null,
          completedTutorials: [...prev.completedTutorials, prev.currentTutorial.id],
        };
      } else {
        // Next step
        return {
          ...prev,
          currentTutorial: {
            ...prev.currentTutorial,
            step: nextStep,
          },
        };
      }
    });
  }, []);

  const skipTutorial = useCallback(() => {
    setTutorialState(prev => {
      if (!prev.currentTutorial) return prev;

      return {
        ...prev,
        isTutorialActive: false,
        currentTutorial: null,
        skippedTutorials: [...prev.skippedTutorials, prev.currentTutorial.id],
      };
    });
  }, []);

  const endTutorial = useCallback(() => {
    setTutorialState(prev => ({
      ...prev,
      isTutorialActive: false,
      currentTutorial: null,
    }));
  }, []);

  return {
    tutorialState,
    startTutorial,
    advanceStep,
    skipTutorial,
    endTutorial,
    setTutorialState,
  };
};

export default useTutorial;
